// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgo_a bhn_bi"};